module.exports = __webpack_public_path__ + "img/拥抱.9b0a1921.gif";